import Breadcrumbs from '../components/Breadcrumbs'
import { createPortal } from 'react-dom'
import { usePortal } from '../hooks/usePortal'
import React from 'react'
import Articles from '../components/Articles'
import getArticles from '../api/getArticles'
import { QuestCard } from '../components/QuestCard'
import { IQuest } from '../server/quests'

const BREADCRUMBS = [
  {
    label: 'Главная',
    path: '/'
  },
  {
    label: 'Опросы',
    path: '/quests'
  }
]

const QuestsPage = () => {
  const { portal } = usePortal()

  return (
    <div className={'page'}>
      <Breadcrumbs className={'page__breadcrumbs'} breadcrumbs={BREADCRUMBS} />
      {portal &&
        createPortal(
          <Breadcrumbs breadcrumbs={BREADCRUMBS}></Breadcrumbs>,
          portal
        )}

      <header className="page__head">
        <h1>Опросы</h1>
      </header>

      <div className="page__content">
        <Articles
          tabsNavigation
          queryMode
          noFilters
          count={9}
          method={(options) => getArticles('/quests/list', options)}
          renderContent={({ items }, loading) => {
            return loading || items.length ? (
              <div className={'app-grid'}>
                {loading
                  ? Array.from({ length: 9 }).map((_, index) => (
                      <QuestCard key={index} loading={true} />
                    ))
                  : items.map((item: IQuest) => (
                      <QuestCard
                        key={item.id}
                        title={item.title}
                        id={item.id}
                        statusText={item.statusText}
                        isActive={item.isActive}
                        loading={loading}
                      />
                    ))}
              </div>
            ) : (
              'Нет данных'
            )
          }}
        ></Articles>
      </div>
    </div>
  )
}

export default QuestsPage
